<template lang="pug">
  div
    b-form-select(
      v-model="filters.despacho"
      placeholder="Despacho"
      :options="dispatchOptions"
      @change="onChange"
    )
</template>

<script>
import { useDashboardStore } from '@/pinia/views/useDashboardStore'
import { mapWritableState } from 'pinia'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      dispatchOptions: [
        { value: null, text: 'Todos los despachos' },
        { value: 'ENVIO', text: 'Envio' },
        { value: 'RETIRO', text: 'Retiro' },
      ],
    }
  },
  beforeMount() {
    this.filters.despacho = null
  },
  async mounted () {
    await this.filters
    this.filters.despacho = null
  },
  methods: {
    ...mapMutations('OT', ['SET_IS_INITIAL_DATA']),
    onChange() {
      this.SET_IS_INITIAL_DATA(false);
    },
  },
  computed: {
    ...mapWritableState(useDashboardStore, ['filters']),    
  },
}

</script>